import { useRef } from 'react';

const useScrollBlock = () => {
  const scroll = useRef(false);

  const blockScroll = () => {
    if (typeof document === 'undefined') return;

    const html = document.documentElement;
    const { body } = document;

    if (!body || !body.style || scroll.current) return;

    const scrollBarWidth = window.innerWidth - html.clientWidth;
    const bodyPaddingRight =
      parseInt(window.getComputedStyle(body).getPropertyValue('padding-right')) || 0;

    const scrollY = window.scrollY;
    body.setAttribute('data-scroll-y', String(scrollY));
    body.style.top = `-${scrollY}px`;
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';
    body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

    scroll.current = true;
  };

  const allowScroll = () => {
    if (typeof document === 'undefined') return;

    const { body } = document;

    if (!body || !body.style || !scroll.current) return;

    const scrollY = parseInt(body.getAttribute('data-scroll-y') || '0', 10);
    body.removeAttribute('data-scroll-y');
    body.style.position = '';
    body.style.top = '';
    body.style.overflow = '';
    body.style.paddingRight = '';
    window.scrollTo(0, scrollY);

    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

export { useScrollBlock };
